import React from 'react';
import { useAuth } from '../context/AuthContext.js';
import logo from '../assets/logo192.png';
import '../styles/Login.css';

/**
 * Pantalla para cuentas que todavía no fueron aprobadas (o fueron rechazadas) en
 * Admin → Aprobación de Usuarios. Reemplaza al panel completo: no ven ninguna sección.
 */
const PendingApproval = ({ status }) => {
    const { currentUser, logout } = useAuth();
    const isRejected = status === 'rejected';

    return (
        <div className="login-container">
            <div className="login-card">
                <div className="login-header">
                    <img src={logo} alt="Lignums Group Logo" className="login-logo" />
                    <h2>{isRejected ? 'Solicitud no aprobada' : 'Cuenta en revisión'}</h2>
                </div>
                <div className="internal-use-notice" role="note">
                    <strong>Herramienta de uso interno exclusivo</strong>
                    <span>Acceso reservado a usuarios autorizados por Lignums.</span>
                </div>
                <p className="pending-approval-text">
                    {isRejected
                        ? 'Tu solicitud de acceso no fue aprobada. Si creés que se trata de un error, comunicate con la persona que te invitó.'
                        : 'Tu cuenta fue creada y está pendiente de aprobación. Vas a poder ingresar al panel cuando el equipo de Lignums la revise.'}
                </p>
                {currentUser?.email && (
                    <p className="pending-approval-email">Cuenta: <strong>{currentUser.email}</strong></p>
                )}
                <button type="button" className="login-button" onClick={logout}>Cerrar sesión</button>
            </div>
        </div>
    );
};

export default PendingApproval;
